import { useParams } from 'react-router'
import MentorEventTypes from 'src/supportPortal/components/common/mentor/eventTypes/MentorEventTypes'

export default function TherapistsEvents() {
  const { mentorSlug } = useParams()
  return (
    <MentorEventTypes
      mentorSlug={mentorSlug}
      fetchSingleMentorSignature={`/api/secure/cc/support/therapists/by-slug?mentor-slug=${mentorSlug}`}
      saveOneOnOnePlanApiSignature={`/api/secure/cc/support/1on1-custom-plan`}
      forTherapist
    />
  )
}
